var inlet = require('aem-libs/src/initInlet.js').initInlet(
  'AemCspsDisbursementCalculator',
  /* global WEBPACK_INLET_VERSION */ WEBPACK_INLET_VERSION
)
var angular = require('angular')
require('angular-route')
var widgetParamsService = require('aem-libs-angularjs/src/services/widgetParams.service').widgetParamsService
require('aem-libs-angularjs/src/components/backend-error/backend-error.component')
require('aem-libs-angularjs/src/components/number-input-plus-minus/number-input-plus-minus.component')
require('aem-libs-angularjs/src/components/number-input-plus-minus-step/number-input-plus-minus-step.component')
require('aem-libs-angularjs/src/components/responsive-date-picker/responsive-date-picker.component')
require('aem-libs-angularjs/src/filters/currency-amount-formatter.filter')
require('aem-libs-angularjs/src/components/tips-rotator/tips-rotator.component')
var dropdown = require('angular-ui-bootstrap/src/dropdown')
require('angularjs-slider/dist/rzslider.min.css')
require('angularjs-slider/dist/rzslider.js')

angular.module('AemCspsDisbursementCalculator', ['ngRoute', 'BackEndErrorComp',
  'NumberInputPlusMinusCmp', 'NumberInputPlusMinusStepCmp', 'ResponsiveDatePickerCmp',
  'currencyAmountFormatterCmp', dropdown, 'rzModule', 'TipsRotatorCmp'])
  .factory('widgetParamsService', widgetParamsService)
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider
      .when('/dps', {
        template: '<tab></tab><dps></dps>'
      })
      .when('/pp', {
        template: '<tab></tab><pp></pp>'
      })
      .otherwise({
        redirectTo: '/dps'
      })
  }])

require('./inlet.css')
require('./inlet.controller.js')

require('aem-libs-angularjs/src/bootstrap').bootstrap({
  element: inlet.element,
  appName: 'AemCspsDisbursementCalculator',
  mainCtrlName: 'AemCspsDisbursementCalculatorCtrl',
  basePath: inlet.basePath,
  config: /* global WEBPACK_INLET_CONFIG */ WEBPACK_INLET_CONFIG,
  supportedLanguages: {
    cs: require('./i18n/cs.js').cs,
    en: require('./i18n/en.js').en
  },
  html: require('./inlet.html')
})
